<template>
  <b-row>
    <b-col cols="12">
      <campaigns-table :key="$route.fullPath" />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CampaignsTable from './CampaignsTable.vue'

export default {
  components: {
    BRow,
    BCol,
    CampaignsTable,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
